import { useState } from 'react';
import { toast } from 'sonner';
import { ts, P } from '../api';
import { Page, Loading, ErrorNote, useLoad, useTS } from '../ui';
import { LeadDetail } from './TSLeads';

export default function TSPipeline() {
  const session = useTS();
  const { data, loading, error, reload } = useLoad(() => ts.pipeline());
  const staff = useLoad(() => (session.can(P.LEADS_ASSIGN) ? ts.staff() : Promise.resolve([])));
  const [open, setOpen] = useState(null);
  const [dragging, setDragging] = useState(null);

  const move = async (leadId, stage) => {
    try { await ts.updateLead(leadId, { ts_stage: stage }); reload(); } catch (e) { toast.error(e.message); }
  };

  if (loading && !data) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  return (
    <Page title="Pipeline" subtitle="Drag a lead to move it to the next stage.">
      <div className="flex gap-3 overflow-x-auto pb-3" data-testid="ts-pipeline">
        {data.stages.map(stage => (
          <div key={stage} className="w-60 shrink-0 rounded-lg bg-muted/50 border border-border"
            onDragOver={e => e.preventDefault()}
            onDrop={() => { if (dragging) move(dragging, stage); setDragging(null); }}
            data-testid={`ts-stage-${stage}`}>
            <div className="px-3 py-2 text-xs font-semibold text-foreground flex justify-between">
              <span>{data.labels[stage]}</span><span className="text-muted-foreground">{data.counts[stage]}</span>
            </div>
            <div className="p-2 space-y-2 min-h-[80px]">
              {data.board[stage].map(l => (
                <button key={l.id} draggable onDragStart={() => setDragging(l.id)} onClick={() => setOpen(l.id)}
                  className="w-full text-left rounded-md bg-card border border-border p-2 text-sm hover:border-violet-500">
                  <div className="font-medium truncate">{l.name}</div>
                  <div className="text-xs text-muted-foreground truncate">{l.phone || l.email}</div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {open && <LeadDetail id={open} staff={staff.data || []} onClose={() => setOpen(null)} onChanged={reload} />}
    </Page>
  );
}
